import { Box, Typography } from "@mui/material";
import { BillingPanel } from "./BillingPanel";
import { MembershipNoteGrid } from "./components";

export const SubscriptionPage = () => {
  const paymentsDisabled = import.meta.env.VITE_PAYMENTS_DISABLED === "true";
  return (
    <Box data-lenis-scroll sx={{ p: { xs: 1.5, sm: 3 }, minHeight: "100%", overflow: "auto" }}>
      <Box sx={{ maxWidth: 960, mx: "auto", pb: 5 }}>
        <Box sx={{ pb: 2.5, borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 800, letterSpacing: "0.12em" }}>
            ♛ YOUR MEMBERSHIP
          </Typography>
          <Typography
            sx={{
              mt: 0.6,
              fontSize: { xs: "2rem", md: "3.5rem" },
              fontWeight: 800,
              letterSpacing: "-0.04em",
              lineHeight: 1,
            }}
          >
            {paymentsDisabled ? "Welcome to open beta." : "Keep Nikola at the board."}
          </Typography>
          <Typography sx={{ mt: 1.2, maxWidth: 620, color: "text.secondary", fontSize: "0.8rem", lineHeight: 1.6 }}>
            {paymentsDisabled
              ? "Game imports, analysis, and Patterns are free during open beta. Nikola chat and memberships are coming soon."
              : "Nikola turns the decisions in your games into a clear next move. This is where your plan, monthly reads, and billing stay together."}
          </Typography>
        </Box>

        <BillingPanel />

        {!paymentsDisabled && (
          <Box sx={{ mt: 4, borderTop: "1px solid", borderColor: "divider" }}>
            <Typography
              variant="caption"
              sx={{ display: "block", pt: 2, color: "primary.main", fontWeight: 800, letterSpacing: "0.12em" }}
            >
              WHAT THE CLUB KEEPS OPEN
            </Typography>
            <MembershipNoteGrid />
          </Box>
        )}
      </Box>
    </Box>
  );
};
